import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ImbpBooking } from "./imbpBooking"
import { IImbpBooking } from "./imbpBooking.types"

export interface IImbpBookingSlotRaw {
  start_time: string
  end_time: string
  date: string
}

export interface IImbpBookingRaw {
  "slot-start-datetime": string
  "slot-end-datetime": string
  "billing-account-id": string
  "customer-name": string
  "customer-email": string
  "customer-phone": string
  "electricity-meter-serial-number"?: string
  "gas-meter-serial-number"?: string
  "display-job-number": string
  "mop-job-number": string
  "aes-patch-availability-id": string
  "cancellation-date-time": string
  "meter-reading-frequency": string
  "junifer-ticket-id": string
  "fuel-type": string
  "created-at": string
  "aes-job-type": string
  "aes-status": string
  "installed-datetime": string
  "failed-datetime": string
  "medical-equipment": boolean
  "installation-type": string
  "meter-type": string
  "appointment-type": string
  source: string
  address: string
  postcode: string
  mpan?: string
  mprn?: string
}

export const ImbpBookingParser: IParser<IImbpBooking, IImbpBookingRaw> = {
  toDomain: (data: IImbpBookingRaw) => {
    try {
      return new ImbpBooking({
        slotStartDateTime: data["slot-start-datetime"],
        slotEndDateTime: data["slot-end-datetime"],
        billingAccountId: data["billing-account-id"],
        customerName: data["customer-name"],
        customerEmail: data["customer-email"],
        customerPhone: data["customer-phone"],
        address: data.address,
        postcode: data.postcode,
        mpan: data.mpan,
        mprn: data.mprn,
        electricityMeterSerialNumber: data["electricity-meter-serial-number"],
        gasMeterSerialNumber: data["gas-meter-serial-number"],
        displayJobNumber: data["display-job-number"],
        mopJobNumber: data["mop-job-number"],
        aesPatchAvailabilityId: data["aes-patch-availability-id"],
        cancellationDateTime: data["cancellation-date-time"],
        meterReadingFrequency: data["meter-reading-frequency"],
        juniferTicketId: data["junifer-ticket-id"],
        fuelType: data["fuel-type"],
        source: data.source,
        createdAt: data["created-at"],
        aesJobType: data["aes-job-type"],
        aesStatus: data["aes-status"],
        installedDatetime: data["installed-datetime"],
        failedDatetime: data["failed-datetime"],
        medicalEquipment: data["medical-equipment"],
        appointmentType: data["appointment-type"],
        meterType: data["meter-type"],
        installationType: data["installation-type"],
      })
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
